<ion-header [translucent]="true" mode="ios" class="ion-no-border">
  @if (showImpersonationBanner) {
    <ion-toolbar mode="ios" class="impersonation-toolbar">
      <c-impersonation-banner />
    </ion-toolbar>
  }
  <ion-toolbar mode="ios">
    @if (isSubpage()) {
      <ion-buttons slot="start">
        @if (customBack()) {
          <ion-back-button (click)="back.emit()" />
        } @else {
          <ion-back-button [defaultHref]="resolvedHref()" />
        }
      </ion-buttons>
      <ion-title>{{ title() }}</ion-title>
    } @else {
      <h1 class="page-header-title ion-no-margin">{{ title() }}</h1>
    }
    <ion-buttons slot="end">
      <ng-content select="[actions]" />
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar mode="ios" class="secondary-toolbar">
    <ng-content select="[secondary-toolbar-content]" />
  </ion-toolbar>
</ion-header>
